import { render, staticRenderFns } from "./module-basic.vue?vue&type=template&id=b25f90fe&"
import script from "./module-basic.vue?vue&type=script&lang=js&"
export * from "./module-basic.vue?vue&type=script&lang=js&"
import style0 from "./module-basic.vue?vue&type=style&index=0&id=b25f90fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports